<template>
  <div class="Team_banner">
    <div class="brand_banner_item">
      <img src="../../assets/team.jpg" />
    </div>
  </div>
  <div class="contaier team">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>主推</span>
            <span class="red">品牌</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">BRAND</div>
      </div>
      <div class="pannel">
        <div class="desc">
          公司长期与西门子、施耐德、欧姆龙、三菱、明纬、ABB、松下、和泉、SMC、亚德客、魏德米勒、昆仑通态、威纶通、德力西、正泰、雷普等国内外知名电气企业保持良好的战略合作关系，共同推动技术创新和市场拓展。
        </div>
        <div class="flex line">
          <div
            v-for="(item, index) in teamdatas"
            :key="item.id"
            :style="{ width: (inner_width - 60) / 5 + 'px' }"
            class="team_box"
          >
            <div
              class="brand_item"
              :style="{
                width:
                  inner_width / 5 -
                  (index == 0 || index == teamdatas.length - 1 ? 15 : 30) +
                  'px',
              }"
            >
              <div class="header" @click="dolook(item.logo)">
                <img :src="item.logo" />
              </div>
            </div>
          </div>
          <el-dialog v-model="dialogVisible" width="25%">
            <img width="98%" height="240px" :src="this.dialogImageUrl" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inner_width: 1020,
      dialogVisible: false,
      dialogImageUrl: "",
      teamdatas: [
        {
          id: 1,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/dcf5c2c6cddf8f0f5b14c4325f3a6402.jpg",
        },
        {
          id: 2,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/0ec7a3eb34e0759aba53cf296d0c2f05.jpg",
        },
        {
          id: 3,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/8b47011a3b8972b53a9f2d11bc3939d6.jpg",
        },
        {
          id: 4,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/612137c22ebc556310075d479a647bf3.jpg",
        },
        {
          id: 5,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/ee9fce25a53c34c051c697724950ddf1.jpg",
        },
        {
          id: 6,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/df5147edf9685891a8766fdfd84d3c1c.jpg",
        },
        {
          id: 7,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/acbc4804c5c4616edaeb6b87e7281c9d.jpg",
        },
        {
          id: 8,
          logo: require("../../assets/hequan.jpg"),
        },
        {
          id: 9,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/ce647e0a5a18ba4d47258c25b1dce8de.jpg",
        },
        {
          id: 10,
          logo: require("../../assets/yadeke.jpg"),
        },
        {
          id: 11,
          logo: require("../../assets/weidemile.jpg"),
        },
        {
          id: 12,
          logo: require("../../assets/kunlun.jpg"),
        },
        {
          id: 13,
          logo: require("../../assets/weiluntong.jpg"),
        },
        {
          id: 14,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/3c7d0cf3674806ae5470cdc0864b6ed4.jpg",
        },
        {
          id: 15,
          logo: require("../../assets/zhengtai.jpg"),
        },
        {
          id: 16,
          logo: require("../../assets/leipu.jpg"),
        },
        {
          id: 17,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/020cdde5132d8b6c1a8fc2a844580015.jpg",
        },
        {
          id: 18,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/b15fdaac9baea2c1ffc32da417767089.jpg",
        },
        {
          id: 19,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/e4e2cce9fc20c31a317f10baf00b5c1c.jpg",
        },
        {
          id: 20,
          logo:
            "//img.wds168.cn/comdata/97885/gallery/764dd59bbd4466952807f84fd4e20eb7.jpg",
        },
      ],
    };
  },
  methods: {
    dolook(url) {
      this.dialogVisible = true;
      this.dialogImageUrl = url;
    },
  },
  mounted() {
    this.inner_width = document.querySelector(".inner").offsetWidth;
  },
};
</script>

<style>
.Team_banner {
  height: 480px;
}
.Team_banner img {
  width: 100%;
  height: 460px;
}
.team .line {
  flex-wrap: wrap;
}
.team .team_box {
  margin-bottom: 20px;
  display: flex;
}
.team .content_title {
  margin-bottom: 20px;
}
.brand_banner_item {
  position: relative;
  width: 100%;
  height: 70vh;
  overflow: hidden;
  padding-top: 5px;
}
.brand_item {
  background: #f8f8f8;
  border-radius: 3px;
  border: 1px solid #efefef;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-left: 10px;
  margin-right: 10px;
  /* cursor: pointer; */
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
}
.team .pannel .line .brand_item .header {
  text-align: center;
  vertical-align: middle;
  align-items: center;
}
.team .pannel .line .brand_item .header img {
  align-items: center;
  text-align: center;
  max-width: 100%;
  width: 240px;
  height: 100px;
  cursor: pointer;
}
.team .pannel .line .brand_item .header:hover img {
  align-items: center;
  text-align: center;
  max-width: 100%;
  width: 260px;
  height: 110px;
}
.brand_item:hover {
  background: #f8f8f8;
  border-radius: 3px;
  border: 1px solid #efefef;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
  /* cursor: pointer; */
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
}
</style>
